module.exports = __webpack_public_path__ + "img/bg-round.164fd73.png";